import React from "react";
import PropTypes from "prop-types";

import AdjustFramingDetailPanel from "./AdjustFramingDetailPanel";
import AdjustFramingThumbnailPanel from "./AdjustFramingThumbnailPanel";

import "./AdjustFramingPane.css";

export default function AdjustFramingPane(props) {
	const {
		variableConfig,
		activeVariableName,
		libraryId,
		shouldUseCredentials = true,
	} = props;
	return (
		<div className="adjust-framing-pane">
			<div className="image-variable-selector-canvas cypress-adjust-framing-image-selector">
				<AdjustFramingThumbnailPanel
					variableConfig={variableConfig}
					activeVariableName={activeVariableName}
					libraryId={libraryId}
				/>
			</div>
			<div className="adjust-frame-clipping-canvas">
				<AdjustFramingDetailPanel
					activeVariableName={activeVariableName}
					libraryId={libraryId}
					shouldUseCredentials={shouldUseCredentials}
				/>
			</div>
		</div>
	);
}

AdjustFramingPane.displayName = "AdjustFramingPane";
AdjustFramingPane.propTypes = {
	activeVariableName: PropTypes.string,
	variableConfig: PropTypes.object.isRequired,
	libraryId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
};
